export interface ErrorResponse {
  object: 'error' | 'error_auth';
  message: string;
}

export const isError = (res: { [key: string]: any }): res is ErrorResponse => typeof res?.object === 'string' && res.object.startsWith('error');

export const isErrorAuth = (res: { [key: string]: any }): res is ErrorResponse => typeof res?.object === 'string' && res.object.startsWith('error_auth');
